import { motion } from "framer-motion";
import { SectionHeader } from "@/components/sections/SectionHeader";

const REASONS = [
  {
    title: "Calitate constantă",
    desc: "Aceeași textură, același gust, aceeași încredere. Zi după zi, lot după lot.",
  },
  {
    title: "Seriozitate în livrare",
    desc: "Știm că în HoReCa timpul costă. De aceea, livrarea și predictibilitatea contează.",
  },
  {
    title: "Produse care economisesc timp",
    desc: "Gata coapte sau congelate, create pentru flux rapid în bucătărie.",
  },
  {
    title: "Gust care aduce clientul înapoi",
    desc: "Un produs bun nu se termină la prima comandă. El aduce revenire.",
  },
];

export default function WhyDotapan() {
  return (
    <section data-testid="why-section" className="section-pad bg-surface-2/40 border-y border-border">
      <div className="max-w-7xl mx-auto container-px grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <SectionHeader
            eyebrow="De ce DOTAPAN"
            title="Calitate pe care o poți pune zilnic în vitrină."
            subtitle="Pentru un restaurant, o cafenea, o pizzerie sau un hotel, produsul trebuie să fie bun de fiecare dată. Nu doar azi. Nu doar când iese norocul bine. La DOTAPAN, lucrăm pentru gust constant, aspect frumos și coacere sigură."
            testId="why-header"
          />
        </div>
        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
          {REASONS.map((r, i) => (
            <motion.div
              key={r.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.07 }}
              className="card-soft p-7 group"
              data-testid={`why-card-${i}`}
            >
              <span className="font-display text-3xl text-gold">0{i + 1}</span>
              <h3 className="mt-3 font-display text-xl text-text">{r.title}</h3>
              <p className="mt-2 text-sm text-text-soft leading-relaxed">{r.desc}</p>
              <div className="mt-5 h-px bg-gradient-to-r from-gold/50 to-transparent" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
